<template>
  <async-alert v-if="exibir" :msg="msg" :tipo="tipo" :icon="icon"/>
</template>

<script>

import AlertMessage from "@/components/alert/AlertConstMessage.js";
import AsyncAlert from "@/components/alert/AsyncAlert.vue";

export default {
  name: "AlertFirmaAberta",
  components: {
    AsyncAlert
  },

  props: {
    pessoa: {},
    tipo: {type:String, default:'alert-icon'}
  },

  computed:{
    msg(){
      return AlertMessage.indicadorPossuiFirmaAberta();
    },

    icon() {
      return "fa-solid fa-pen-field";
    },

    exibir() {
      let firma = this.pessoa?.firma || this.pessoa?.indicadorPessoal?.firma;
      return this.$root.atribuicaoAtiva('NOTAS') && !!firma;
    }
  }
}
</script>
